import * as React from "react";
import { color } from "../../../styles/color";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { IDeviceConnection } from "../../../api_types";
import { StyledSecondTable } from "../../../styles/DeviceConnet";

interface IProps {
  unNormal: IDeviceConnection[];
  loading: boolean;
}

const SecondStyledTable = ({ unNormal, loading }: IProps) => {
  const linkColumns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
    },
    {
      title: "踏板别名",
      dataIndex: "DeviceName",
      width: 150,
    },
    {
      title: "连线状态",
      dataIndex: "ClientStatus",
      width: 100,
      render: (text: string) => (
        <div>{parseInt(text) === 0 ? "无" : "连线"}</div>
      ),
    },
    {
      title: "踏板ID",
      dataIndex: "DeviceUUID",
      width: 150,
    },
    {
      title: "最后回应时间",
      dataIndex: "RecentlyWhenReceivedAnyData",
      width: 150,
      render: (text: string) => (
        <div className="">{text.replace(/T/g, " ")}</div>
      ),
    },
  ];
  return (
    <StyledSecondTable
      columns={linkColumns}
      dataSource={unNormal}
      pagination={false}
      scroll={{ x: "max-content" }}
      size={"small"}
      rowKey="DeviceUUID"
      loading={loading}
      sticky
      title={() => (
        <div
          className="unlinkDevice"
          style={{
            backgroundColor: "white",
            color: `${color.markedDefault}`,
          }}
        >
          <QuestionCircleOutlined /> 异常连线踏板
        </div>
      )}
      bordered
    />
  );
};

export default SecondStyledTable;
